<div class="empty-state tw:flex tw:items-center tw:justify-between tw:gap-3">
  <span>{{ message }}</span>
  @if (ctaLabel) {
    <button vee-btn="filled" class="cyan" (click)="cta.emit()">
      @if (ctaIcon) {
        <vee-icon [icon]="ctaIcon"></vee-icon>
      }
      {{ ctaLabel }}
    </button>
  }
</div>
